import { make, type t as IconName } from './Icon.gen'

type IconProps = React.ComponentProps<typeof make>

const Icon = make as React.FunctionComponent<IconProps>

export { Icon, type IconProps, type IconName }
